import { Injectable, inject } from '@angular/core';
import type { RouterStateSnapshot, UrlTree } from '@angular/router';
import { Router } from '@angular/router';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { Store } from '@ngrx/store';
import { bankAccount, bankingPartner, user } from '@stores/banking/banking-ngrx.selector';
import type { BankingBankAccount, BankingPartner, BankingUser } from '@wizbii/utils/models';
import { TrackStatusEnum } from '@wizbii/utils/models';
import type { Observable } from 'rxjs';
import { combineLatest } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CanValidateIbanGuard {
  #store = inject(Store);
  #router = inject(Router);

  canActivate(_: any, _state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return combineLatest([
      this.#store.select(user),
      this.#store.select(bankAccount),
      this.#store.select(bankingPartner),
    ]).pipe(
      filter(([bankingUser, _, partner]) => partner !== null && !!bankingUser?.userId && !!partner?.label),
      take(1),
      map(([bankingUser, bankAccount, partner]) => {
        if (this.canValidateIban(bankingUser!, partner!, bankAccount!)) {
          return true;
        }

        return this.#router.parseUrl(`/${FeaturesRoutingEnum.Dashboard}`);
      })
    );
  }

  canValidateIban(bankingUser?: BankingUser, partner?: BankingPartner, bankAccount?: BankingBankAccount): boolean {
    return (
      bankingUser?.trackInfo.status === TrackStatusEnum.Completed &&
      !!partner?.label &&
      !partner.provideUserIban &&
      !bankAccount?.currentBankAccount?.iban
    );
  }
}
